"use client";

import { ChevronDown } from "lucide-react";
import Link from "next/link";
import React from "react";
import MenuProducts from "./components/MenuProducts";

const LinkProducts = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <div
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <Link
        className={`text-sm flex items-center ${
          open ? "text-pink font-bold" : "text-text"
        }`}
        href=""
      >
        محبوب ترین عطر ها
        <ChevronDown className="size-4 ml-1" />
      </Link>
      <div
        className={`absolute left-1/2 transform -translate-x-1/2 transition-opacity duration-300 ${
          open ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <MenuProducts />
      </div>
    </div>
  );
};

export default LinkProducts;
